<div class="mx-auto box-content max-w-screen-xl px-3">
  <ng-content />
</div>
